define('models/composer/forms/qualityScore/EvaluationScore',[
    'lib/knockout',
    'lib/lodash4',
    'util/ObservableModel',
    'models/composer/forms/qualityScore/QuestionGroupScore'
], function (ko, _, ObservableModel, QuestionGroupScoreModel) {
    'use strict';

    //
    // Quality Score Result - Evaluation Score Model
    //
    var EvaluationScoreModel = ObservableModel.extend({
        defaults: {
            type: 'evaluationScore',
            formId: '',
            formName: '',
            totalScore: 0,
            totalCriticalScore: 0,
            questionGroupScores: [],
            anyFailedKillQuestions: false
        },
        modelProperties: {
            questionGroupScores: QuestionGroupScoreModel
        }
    }, function qualityScoreResultModel_init() {
        var self = this;

        self.modelId = _.uniqueId('evaluationScore'); //Create an id like "fooXX"
    });

    return EvaluationScoreModel;
});
